module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "Approve"
  }, [_c('rt-plat-header', {
    attrs: {
      "title": "审批"
    }
  }, [_c('rt-toolbar', {
    attrs: {
      "show-autoback": ""
    }
  })], 1), _vm._v(" "), _c('rt-content', {
    attrs: {
      "id": "approvemain"
    }
  }, [_c('div', {
    staticClass: "appcontent"
  }, [_c('div', {
    class: _vm.isMyApproval ? '' : 'leftAll',
    attrs: {
      "id": "left"
    }
  }, [_c('el-tabs', {
    class: _vm.approveShowBtn ? 'approve_card_btn' : 'approve_card',
    attrs: {
      "type": "border-card",
      "tab-position": _vm.tabPosition
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [(_vm.decisiondisplayes) ? _c('el-tab-pane', {
    attrs: {
      "name": "page"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$_t("单据详情", "approval.formdetail")))]), _vm._v(" "), _c(_vm.formCom, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$_t('审批信息', 'approval.approvalinfo'),
      "name": "approve"
    }
  }, [_c('div', {
    staticClass: "rt-flow-left"
  }, [_c('rt-flow-approval-list', {
    ref: "_RTFlowApprovalList",
    attrs: {
      "entityname": _vm.entityName,
      "id": _vm.entityId
    }
  })], 1)])], 1)], 1), _vm._v(" "), (_vm.isMyApproval) ? _c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('div', {
    staticClass: "rt-crm-ApproveHeader"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveTitle"
  }, [(_vm.iscommunicate == 0) ? _c('span', [_vm._v(_vm._s(_vm.$_t("签核处理", "approval.signprocess")))]) : _c('span', [_vm._v("签核沟通")])])]), _vm._v(" "), (_vm.iscommunicate == 0) ? _c('div', {
    staticClass: "rt-crm-ApproveContent"
  }, [_c('ul', {
    staticClass: "rt-crm-ApproveTabList"
  }, [_c('li', {
    staticClass: "rt-crm-ApproveTab",
    class: {
      selected: _vm.actionType == 1
    },
    on: {
      "click": function($event) {
        _vm.actionType = 1
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$_t("同意", "approval.agree")))])]), _vm._v(" "), _c('li', {
    staticClass: "rt-crm-ApproveTab",
    class: {
      selected: _vm.actionType == 2
    },
    on: {
      "click": function($event) {
        _vm.actionType = 2
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$_t("驳回", "approval.reject")))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allowCommunicate),
      expression: "allowCommunicate"
    }],
    staticClass: "rt-crm-ApproveTab",
    class: {
      selected: _vm.actionType == 3
    },
    on: {
      "click": function($event) {
        _vm.actionType = 3
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$_t("沟通", "approval.communicate")))])]), _vm._v(" "), _c('li', {
    staticClass: "rt-crm-ApproveTab",
    class: {
      selected: _vm.actionType == 4
    },
    on: {
      "click": function($event) {
        _vm.actionType = 4
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$_t("转办", "approval.transfer")))])])]), _vm._v(" "), (_vm.actionType == 1) ? _c('div', {
    staticClass: "rt-crm-ApproveTabContent"
  }, [_c('div', [_c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                  " + _vm._s(_vm.$_t("签核意见", "approval.endorsingopinions"))), (_vm.ApproveMemoRequired) ? _c('span', [_vm._v("(" + _vm._s(_vm.$_t("必填", "common.isrequired")) + ")")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreeInfo.memo),
      expression: "agreeInfo.memo"
    }],
    staticClass: "rt-crm-ApproveMemo",
    attrs: {
      "placeholder": _vm.$_t('请填写', 'common.fillOut') +
        _vm.$_t('签核意见', 'approval.endorsingopinions')
    },
    domProps: {
      "value": (_vm.agreeInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreeInfo, "memo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-ApproveSection",
    staticStyle: {
      "margin-top": "36px"
    }
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                  " + _vm._s(_vm.$_t("加签用户", "approval.signeduser")) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "userSelect"
  }, [_c('rt-radio-group', {
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('rt-radio-button', {
    attrs: {
      "label": 0,
      "border": ""
    }
  }, [_vm._v("互联用户")]), _vm._v(" "), _c('rt-radio-button', {
    attrs: {
      "label": 1,
      "border": ""
    }
  }, [_vm._v("系统用户")])], 1)], 1), _vm._v(" "), _vm._l((_vm.addUsers), function(user) {
    return _c('div', {
      key: user.systemuserid,
      staticClass: "rt-crm-AddedUser"
    }, [_c('div', {
      staticClass: "rt-crm-Avatar"
    }, [_vm._v(_vm._s(user.fullname))]), _vm._v(" "), _c('div', {
      staticClass: "rt-crm-DeleteMask",
      on: {
        "click": function($event) {
          return _vm.deleteAddUser(user, 1)
        }
      }
    }, [_c('i')]), _vm._v(" "), _c('p', {
      staticClass: "rt-crm-UserName"
    }, [_vm._v(_vm._s(user.fullname))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-AddUser",
    on: {
      "click": function($event) {
        return _vm.chooseAddUser()
      }
    }
  }, [_c('div', {
    staticClass: "rt-crm-Avatar"
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-UserName"
  }, [_vm._v("\n                    " + _vm._s(_vm.$_t("新增", "common.add")) + "\n                  ")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.actionType == 2) ? _c('div', {
    staticClass: "rt-crm-ApproveTabContent"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("驳回到", "approval.refute")) + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectInfo.rejectToStepId),
      expression: "rejectInfo.rejectToStepId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rejectInfo, "rejectToStepId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$_t("申请人", "new_flowapprovalcrf.new_applyuser")))]), _vm._v(" "), _vm._l((_vm.approvedStepList), function(step) {
    return _c('option', {
      key: step.new_stepid,
      domProps: {
        "value": step.new_stepid
      }
    }, [_vm._v(_vm._s(step.new_stepidName))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableRejectType && !_vm.isDynamicFlow),
      expression: "enableRejectType && !isDynamicFlow"
    }],
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("驳回选项", "approval.rejectedoption")) + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectInfo.resubmitTypeId),
      expression: "rejectInfo.resubmitTypeId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rejectInfo, "resubmitTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$_t(
    "驳回后流经的子流程重新流转",
    "approval.afterrefusedrestart"
  )))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$_t(
    "驳回的节点通过后直接返回本节点",
    "approval.afterrefusedcontinue"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("签核意见", "approval.endorsingopinions"))), (_vm.ApproveMemoRequired) ? _c('span', [_vm._v("(" + _vm._s(_vm.$_t("必填", "common.isrequired")) + ")")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectInfo.memo),
      expression: "rejectInfo.memo"
    }],
    staticClass: "rt-crm-ApproveMemo",
    attrs: {
      "placeholder": _vm.$_t('签核意见', 'approval.endorsingopinions') +
        '' +
        _vm.$_t('必填', 'common.isrequired')
    },
    domProps: {
      "value": (_vm.rejectInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rejectInfo, "memo", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.actionType == 3) ? _c('div', {
    staticClass: "rt-crm-ApproveTabContent"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("沟通用户", "approval.communicateusers")) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "userSelect"
  }, [_c('rt-radio-group', {
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('rt-radio-button', {
    attrs: {
      "label": 0,
      "border": ""
    }
  }, [_vm._v("互联用户")]), _vm._v(" "), _c('rt-radio-button', {
    attrs: {
      "label": 1,
      "border": ""
    }
  }, [_vm._v("系统用户")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-AddedUserList"
  }, [_vm._l((_vm.communicateInfo.userList), function(user) {
    return _c('div', {
      key: user.systemuserid,
      staticClass: "rt-crm-AddedUser"
    }, [_c('div', {
      staticClass: "rt-crm-Avatar"
    }, [_vm._v(_vm._s(user.fullname))]), _vm._v(" "), _c('div', {
      staticClass: "rt-crm-DeleteMask",
      on: {
        "click": function($event) {
          return _vm.deleteCommunicateUser(user)
        }
      }
    }, [_c('i')]), _vm._v(" "), _c('p', {
      staticClass: "rt-crm-UserName"
    }, [_vm._v(_vm._s(user.fullname))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-AddUser",
    on: {
      "click": function($event) {
        return _vm.chooseAddUser()
      }
    }
  }, [_c('div', {
    staticClass: "rt-crm-Avatar"
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-UserName"
  }, [_vm._v("\n                    " + _vm._s(_vm.$_t("新增", "common.add")) + "\n                  ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('h4', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("备注", "SER_Notes"))), (_vm.ApproveMemoRequired) ? _c('span', [_vm._v("(" + _vm._s(_vm.$_t("必填", "common.isrequired")) + ")")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communicateInfo.memo),
      expression: "communicateInfo.memo"
    }],
    staticClass: "rt-crm-ApproveMemo",
    attrs: {
      "placeholder": _vm.$_t('请填写备注', 'PLEASE_FILL_IN_THE_NOTES')
    },
    domProps: {
      "value": (_vm.communicateInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.communicateInfo, "memo", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.actionType == 4) ? _c('div', {
    staticClass: "rt-crm-ApproveTabContent"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("转办给", "approval.transferusers")) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "userSelect"
  }, [_c('rt-radio-group', {
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('rt-radio-button', {
    attrs: {
      "label": 0,
      "border": ""
    }
  }, [_vm._v("互联用户")]), _vm._v(" "), _c('rt-radio-button', {
    attrs: {
      "label": 1,
      "border": ""
    }
  }, [_vm._v("系统用户")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-AddedUserList"
  }, [_vm._l((_vm.transferInfo.userList), function(user, index) {
    return _c('div', {
      key: user.systemuserid,
      staticClass: "rt-crm-AddedUser"
    }, [_c('div', {
      staticClass: "rt-crm-Avatar"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("surname")(user.fullname)) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "rt-crm-DeleteMask",
      on: {
        "click": function($event) {
          return _vm.deleteTransferUser(index)
        }
      }
    }, [_c('i')]), _vm._v(" "), _c('p', {
      staticClass: "rt-crm-UserName"
    }, [_vm._v(_vm._s(user.fullname))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transferInfo.userList.length == 0),
      expression: "transferInfo.userList.length == 0"
    }],
    staticClass: "rt-crm-AddUser",
    on: {
      "click": function($event) {
        return _vm.chooseAddUser()
      }
    }
  }, [_c('div', {
    staticClass: "rt-crm-Avatar"
  }, [_vm._v("+")]), _vm._v(" "), _c('p', {
    staticClass: "rt-crm-UserName"
  }, [_vm._v("\n                    " + _vm._s(_vm.$_t("新增", "common.add")) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('h4', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                " + _vm._s(_vm.$_t("备注", "SER_Notes"))), (_vm.ApproveMemoRequired) ? _c('span', [_vm._v("(" + _vm._s(_vm.$_t("必填", "common.isrequired")) + ")")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transferInfo.memo),
      expression: "transferInfo.memo"
    }],
    staticClass: "rt-crm-ApproveMemo",
    attrs: {
      "placeholder": _vm.$_t('请填写备注', 'PLEASE_FILL_IN_THE_NOTES')
    },
    domProps: {
      "value": (_vm.transferInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.transferInfo, "memo", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-submit",
    class: {
      marginTop54: [2, 3, 4].includes(_vm.actionType)
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.btnloading,
      "loading": _vm.btnloading
    },
    on: {
      "click": _vm.approve
    }
  }, [_vm._v(_vm._s(_vm.$_t("提交", "BUTTON_SUBMIT")))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.iscommunicate == 1) ? _c('div', {
    staticClass: "rt-crm-ApproveContent"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveTabContent"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('p', {
    staticStyle: {
      "color": "#000",
      "font-size": "16px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.communicateBy.UserName) + "\n              ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#555",
      "font-size": "14px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.communicateBy.Memo) + "\n              ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rt-crm-ApproveSection"
  }, [_c('div', {
    staticClass: "rt-crm-ApproveSectionTitle"
  }, [_vm._v("\n                  处理意见"), (_vm.ApproveMemoRequired) ? _c('span', [_vm._v("(" + _vm._s(_vm.$_t("必填", "common.isrequired")) + ")")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communicate.memo),
      expression: "communicate.memo"
    }],
    staticClass: "rt-crm-ApproveMemo",
    attrs: {
      "placeholder": "请填写处理意见"
    },
    domProps: {
      "value": (_vm.communicate.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.communicate, "memo", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rt-crm-submit marginTop54"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.btnloading,
      "loading": _vm.btnloading
    },
    on: {
      "click": _vm.approve
    }
  }, [_vm._v(_vm._s(_vm.$_t("提交", "BUTTON_SUBMIT")))])], 1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('rt-plat-lookup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "selectUser",
    attrs: {
      "entity": _vm.lookupList[_vm.radio].entity,
      "idField": _vm.lookupList[_vm.radio].idField,
      "disabled": false,
      "nameField": _vm.lookupList[_vm.radio].nameField,
      "dialog-display-fields": _vm.lookupList[_vm.radio].dialogDisplayFields,
      "dialog-order-fields": _vm.lookupList[_vm.radio].dialogOrderFields,
      "dialogFilterFields": _vm.lookupList[_vm.radio].dialogFilterFields,
      "dialogConditionFields": "isdisabled eq false"
    },
    model: {
      value: (_vm.selectUserId),
      callback: function($$v) {
        _vm.selectUserId = $$v
      },
      expression: "selectUserId"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17da71cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/vflow/Approve.vue
// module id = 2024
// module chunks = 228